import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import OrderServicesTypeList from './OrderServicesTypeList.js';
import Programming from './Programming';
import Calculation from './Calculation';
import Layout from './Layout';
import SuccessMessage from './SuccessMessage';
import urlParser from '../utils/urlParser';
import config from '../config.json';
import dayjs from 'dayjs';

export default function FormComponent() {
  /**
   *  default service type AcademicWriting (45)
   */
  const defaultAcademicConfig = config.configsForAcademicWriting;
  const defaultProgramingConfig = config.configsForProgramming;
  const defaultCalculationConfig = config.configsForCalculations;
  const [success, setSuccess] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  const [state, setState] = useState({
    orderServiceTypeId: 45,
    disciplineId: defaultCalculationConfig.defaults.disciplineId,
    deadline: {
      id: null,
      value: ''
    },
    size: {},
  });

  const setCurrentDeadline = (params) => {
    let deadlineListForCurrentService;
    let defaultsForCurrentService;

    switch (+params?.orderServiceTypeId) {
      case 45:
        deadlineListForCurrentService = defaultCalculationConfig.deadlines;
        defaultsForCurrentService = defaultCalculationConfig.defaults;
        break;
      case 46:
      default:
        deadlineListForCurrentService = defaultProgramingConfig.deadlines;
        defaultsForCurrentService = defaultProgramingConfig.defaults;
        break;
    }
    return dayjs()
      .add(deadlineListForCurrentService
        .filter(d => d.id === defaultsForCurrentService.deadlineId)[0].hours, 'hours')
        .format('MMM DD, YYYY [at] HH:mm A')
        .toString();

  }

  useEffect(() => {
    window.addEventListener('load', () => {
      const params = urlParser();
      const formConfig = JSON.parse(document.querySelector('[data-form-config]')?.dataset.formConfig);
      if (formConfig) {
        setServicesList(Object.values(formConfig).filter((service, index) => {
          if (service.isEnabled) {
            return service;
          }
        }).filter((service, index) => {
          if (index === 0) {
            setState({
              ...state,
              orderServiceTypeId: service.id,
              ...params,
              // deadline: {
              //   id: +params?.tariffId,
              //   value: setCurrentDeadline(params)
              // },
            })
          }
          return service;
        }))
      }
    })

  }, [])
  const renderForm = () => {
    switch (+state.orderServiceTypeId) {
      case 46:
        return (
          <Programming
            state={state}
            setState={setState}
          />
        );
      case 45:
      default:
        return (
          <Calculation
            state={state}
            setState={setState}
          />
        );
    }
  }

  const formSubmit = () => {
    const formData = new FormData();
    const sendRequest = (data) => {
       fetch(`${helper.ajaxurl}?action=submit_free_quote_form`, {
        method: 'POST',
        body: data
      }).then((response) => {
        if (response.ok) {
          setSuccess(true);
        }
      }).finally(() => {
      });
    }

    switch (+state.orderServiceTypeId) {
      case 46:
        formData.append('orderServiceType', 'Programming');
        formData.append('deadline', state.deadline.value);
        formData.append('discipline', config.disciplines.filter(i => i.id === +state.disciplineId)[0].name);
        formData.append('size', state.size.name)
        sendRequest(formData);
        break;
      case 45:
      default:
        formData.append('orderServiceType', 'Calculations');
        formData.append('deadline', state.deadline.value);
        formData.append('discipline', config.disciplines.filter(i => i.id === +state.disciplineId)[0].name);
        formData.append('size', state.size.name);
        sendRequest(formData);
        break;
    }
  }

  return (
    <Fragment>
      {servicesList.length > 0 && (
        <Fragment>
          {!success && (
            <form action="">
              <OrderServicesTypeList
                state={state}
                setState={setState}
                servicesList={servicesList}
              />
              {renderForm()}
              <Layout.Row>
                <div className="form-control form-control--rowspan2">
                  <button
                    className="btn btn--orange submit-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      formSubmit();
                      document.querySelector('.form-heading').style.display = 'none';
                    }}
                  >Submit quote
                  </button>
                </div>
              </Layout.Row>
            </form>
          )}
          {success && (
            <SuccessMessage />
          )}
        </Fragment>
      ) }
    </Fragment>
  )
}
